import { makeStyles } from '@material-ui/core';
import textureImg from '../../../static/images/texture_transparent.png';

export const useDetailStyles = makeStyles(() => ({
    radioWrapper: {
        margin: '8px 0',

        '& .MuiFormControlLabel-root': {
            marginTop: 0,
        },
    },
    testSelect: {
        marginRight: '8px',

        '& .MuiSelect-select': {
            minWidth: 390,
        },
    },
    selectionError: {
        color: '#BF3D56',
    },
    callVia: {
        border: 'thin solid rgb(220, 220, 220)',
        padding: '16px 0px 16px 16px',
    },
}));

export const useResultStyles = makeStyles((theme) => ({
    partyTable: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '30px',
        width: '100%',
        tableLayout: 'fixed',
    },
    partyTableColumn: {
        width: '50%',
    },
    partySummaryBlock: {
        display: 'inline-block',
        width: 'fit-content',
        maxWidth: '560px',
        margin: '0 auto',
        textAlign: 'center',
    },
    text: {
        fontSize: '14px',
        fontWeight: '100',
        padding: '20px 0',
    },
    error: {
        color: 'red',
    },
    callProgress: {
        height: 6,
        minWidth: 280,
        borderRadius: 3,

        '& .MuiLinearProgress-bar': {
            borderRadius: 3,
        },
    },
    callProgressWrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    gaugeWrapper: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    tabContentQuality: {
        backgroundColor: theme.palette.background.paper,
    },
    qualityChartsTable: {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: theme.palette.background.paper,
    },
    chartTd: {
        width: '50%',
        backgroundColor: theme.palette.background.paper,
        verticalAlign: 'top',
    },
    partyMetricsTable: {
        marginTop: '12px',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderCollapse: 'collapse',
        '& td': {
            textAlign: 'center',
            padding: '0 60px',
        },
        '& td:first-child': {
            paddingLeft: 0,
        },
        '& td:last-child': {
            paddingRight: 0,
        },
    },
    phoneContainer: {
        marginTop: '24px',
    },
    phoneNumberText: {
        width: '100%',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    mdIcon: {
        fontSize: '140px',
        color: '#757575',
    },
    callerMetrics: {
        padding: '7px 0',
        height: 'auto',
        width: 'auto',
        textAlign: 'right',
    },
    calleeMetrics: {
        padding: '7px 0',
        height: 'auto',
        width: 'auto',
        textAlign: 'left',
    },
    metricLabel: {
        height: 'auto',
        minWidth: '200px',
        textAlign: 'center',
        verticalAlign: 'middle',
        fontSize: '13px',
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
    },
    callFlowContainer: {
        marginLeft: '40px',
        padding: '20px 0',
        backgroundColor: theme.palette.background.paper,
        '& a': {
            cursor: 'pointer',
        },
    },
    callFlowBreak: {
        background:
            theme.palette.type === 'dark'
                ? `url(${textureImg}) repeat scroll 0% 0% #4A4A4A`
                : `url(${textureImg}) repeat scroll 0% 0% #EFEFEF`,
        color: theme.palette.type === 'dark' ? '#EAEAEA' : '#999',
        fontStyle: 'italic',
        fontSize: '1.1em',
        fontWeight: 'bold',
    },
    callFlowCmCell: {
        backgroundColor: theme.palette.type === 'dark' ? '#575757 !important' : '#999 !important',
        color: '#FFF',
    },
    tdLeft: {
        textAlign: 'left !important',
    },
    tdCenter: {
        textAlign: 'center !important',
    },
    tdRight: {
        textAlign: 'right !important',
    },
    tdTop: {
        verticalAlign: 'top !important',
    },
    tdMiddle: {
        verticalAlign: 'middle !important',
    },
    tdBottom: {
        verticalAlign: 'bottom !important',
    },
    tdBold: {
        fontWeight: 'bold',
    },
    tableStriped: {
        marginBottom: '0px',
        width: '900px',
        borderCollapse: 'collapse',
        color: theme.palette.text.primary,
        '& th, & td': {
            padding: '5px',
            lineHeight: '1.42857143',
        },
        '& tbody > tr': {
            borderBottom: `1px solid ${theme.palette.type === 'dark' ? '#FFF' : theme.palette.divider}`,
        },
        '& tbody > tr:first-child': {
            borderTop: `1px solid ${theme.palette.type === 'dark' ? '#FFF' : theme.palette.divider}`,
        },
        '& tbody > tr:last-child': {
            borderBottom: 'none',
        },
        '& tbody > tr:nth-child(odd)': {
            backgroundColor: theme.palette.type === 'dark' ? '#4A4A4A' : '#f9f9f9',
        },
    },

    printTabHeader: {
        display: 'block',
        whiteSpace: 'nowrap',
        fontSize: '16px',
        fontWeight: 100,
        borderBottom: '#ddd solid 1px',
        width: '100%',
        padding: '10px',
    },
    printTabSection: {
        marginTop: '10px',
        '&:first-child': {
            marginTop: 0,
        },
    },
    printHiddenTabs: {
        display: 'none !important',
    },
}));
